function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcon = function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M74.155 39.06V3.852l35.208 35.208z",
    style: {
      fill: "#b6ccf9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.742 3.852V125.48h89.621V38.783H74.432V3.852zm49.404 48.455h.057q1.341-.001 2.168 1.054.798 1.14.371 2.452L60.25 91.145q-.57 1.882-2.566 1.882h-.086q-1.37.001-2.139-1.054-.77-1.027-.371-2.397L66.58 54.188q.627-1.882 2.566-1.881M50.871 59.32q1.37.057 2.281.998.942.914.942 2.282 0 2.167-2.026 3.023l-17.423 7.072 17.423 7.073q2.025.827 2.026 3.023 0 1.454-.942 2.395-.912.94-2.28.941-.63 0-1.284-.314l-21.559-9.268q-2.51-1.083-2.51-3.793 0-2.766 2.51-3.85l21.559-9.324q.656-.314 1.283-.258m26.264 0q.656-.056 1.283.258l21.559 9.324q2.48 1.084 2.48 3.85 0 2.709-2.48 3.793l-21.559 9.267a2.84 2.84 0 0 1-1.283.315q-1.312 0-2.252-.941-.942-1.055-.998-2.395 0-2.196 2.052-3.023l17.368-7.073-17.368-7.072q-2.052-.856-2.052-3.023.056-1.369.998-2.282a3.29 3.29 0 0 1 2.252-.998",
    style: {
      fill: "#487fef"
    }
  }));
};
export default SvgIcon;